import Header from './Header.jsx';
import DashboardTabs from './DashboardTabs.jsx';
import { PRIMARY_TABS } from '../constants/tabs';
import '../styles/dashboard-page-frame.css';

export default function DashboardPageFrame({
  primaryTabActiveIndex = 0,
  primaryTabs = PRIMARY_TABS,
  sectionLabel = 'Dashboard',
  secondaryTabs = [],
  secondaryTabActiveIndex = 0,
  secondaryTabsContainerClassName = 'db-dashboard-secondary-tabs',
  stickyAreaClassName = 'db-dashboard-sticky-area',
  children,
  rootClassName = '',
  mainClassName = '',
}) {
  return (
    <div className={`${rootClassName} db-dashboard-frame`.trim()}>
      <Header
        primaryTabActiveIndex={primaryTabActiveIndex}
        primaryTabs={primaryTabs}
        sectionLabel={sectionLabel}
        variant="compact"
      />

      <main className={`${mainClassName} db-dashboard-main`.trim()}>
        {secondaryTabs.length > 0 && (
          <div className={stickyAreaClassName}>
            <DashboardTabs
              activeIndex={secondaryTabActiveIndex}
              containerClassName={secondaryTabsContainerClassName}
              items={secondaryTabs}
              variant="secondary"
            />
          </div>
        )}

        {children}
      </main>
    </div>
  );
}
